export default __webpack_public_path__ + "static/media/home-active.489c807c.svg";